"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findJavaHomeInSubfolder = exports.downloadAndExtractJDK = exports.getLatestRelease = void 0;
const c = __importStar(require("./constants"));
const core = __importStar(require("@actions/core"));
const httpClient = __importStar(require("@actions/http-client"));
const tc = __importStar(require("@actions/tool-cache"));
const core_1 = require("@octokit/core");
const path_1 = require("path");
const fs_1 = require("fs");
// Set up Octokit in the same way as @actions/github (see https://git.io/Jy9YP)
const baseUrl = process.env['GITHUB_API_URL'] || 'https://api.github.com';
const GitHub = core_1.Octokit.defaults({
    baseUrl,
    request: {
        agent: new httpClient.HttpClient().getAgent(baseUrl)
    }
});
function getLatestRelease(repo) {
    return __awaiter(this, void 0, void 0, function* () {
        const githubToken = core.getInput('github-token');
        const options = githubToken.length > 0 ? { auth: githubToken } : {};
        const octokit = new GitHub(options);
        return (yield octokit.request('GET /repos/{owner}/{repo}/releases/latest', {
            owner: c.GRAALVM_GH_USER,
            repo
        })).data;
    });
}
exports.getLatestRelease = getLatestRelease;
function downloadAndExtractJDK(downloadUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const downloadPath = yield tc.downloadTool(downloadUrl);
        if (downloadUrl.endsWith('.tar.gz')) {
            yield tc.extractTar(downloadPath, c.GRAALVM_BASE);
        }
        else if (downloadUrl.endsWith('.zip')) {
            yield tc.extractZip(downloadPath, c.GRAALVM_BASE);
        }
        else {
            throw new Error(`Unexpected filetype downloaded: ${downloadUrl}`);
        }
        return findJavaHomeInSubfolder(c.GRAALVM_BASE);
    });
}
exports.downloadAndExtractJDK = downloadAndExtractJDK;
function findJavaHomeInSubfolder(searchPath) {
    const baseContents = (0, fs_1.readdirSync)(searchPath);
    if (baseContents.length === 1) {
        return (0, path_1.join)(searchPath, baseContents[0], c.JDK_HOME_SUFFIX);
    }
    else {
        throw new Error(`Unexpected amount of directory items found: ${baseContents.length}`);
    }
}
exports.findJavaHomeInSubfolder = findJavaHomeInSubfolder;
